import { Directive, ElementRef, ViewContainerRef, Input } from '@angular/core';
import { CommonService } from '../_services/common.service';

@Directive({
  selector: '[psiCanAccessMore]'
})
export class CanAccessMoreDirective {

  @Input() psiCanAccessMore: [string];
  @Input() psiOperator: string;

  constructor(private elementRef: ElementRef, private viewContainer: ViewContainerRef, private commonService:CommonService) { }

    ngOnInit():void{
      this.checkPermission();
    }
    private checkPermission():void{
      let hasAccess:boolean = false;
      
      if(this.psiCanAccessMore){
        hasAccess = this.commonService.checkPermissions(this.psiCanAccessMore, this.psiOperator);
      }

     if(!hasAccess){
        this.elementRef.nativeElement.remove(); 
      }
    }
}
